<div class="buttons has-addons">
  <button class="button" title="Yes" i18n-title>Yes</button>
  <button class="button is-info is-selected" title="Maybe" i18n-title>Maybe</button>
  <button class="button" title="No" i18n-title>No</button>
</div>
1
